// 有料短视频
export const SET_YL_ALL_DATA = "SET_YL_ALL_DATA"


// WEBPACK FOOTER //
// ./src/store/mutation-types.js